import { Field } from '@datx/core';
import { JsonApiModel } from '../../core/jsonApi/jsonApiModel';
import { LearningSectionJsonModel } from '../learning-section.json.model';
import { SequenceJsonModel } from '../../sequence/sequence.json.model';
import { ExplanationJsonModel } from '../../explanation/explanation.json.model';
import { ExplanationContentJsonModel } from '../../explanation/content/explanation-content.json.model';
import { TestJsonModel } from '../../test/test.json.model';
export class LearningSectionContainerJsonModel extends JsonApiModel {
  public static override readonly type = 'learning-section-containers';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public title!: string;

  @Field()
  public order!: number;

  @Field()
  public fullWidth!: boolean;

  @Field()
  public version!: number;

  @Field({ toMany: LearningSectionJsonModel })
  public learningSections?: LearningSectionJsonModel[];

  @Field({ toOne: SequenceJsonModel || ExplanationJsonModel || ExplanationContentJsonModel || TestJsonModel })
  public content!: SequenceJsonModel | ExplanationJsonModel | ExplanationContentJsonModel | TestJsonModel;
}
